import { render, staticRenderFns } from "./WorkAuthorization.vue?vue&type=template&id=48084078&scoped=true&"
import script from "./WorkAuthorization.vue?vue&type=script&lang=ts&"
export * from "./WorkAuthorization.vue?vue&type=script&lang=ts&"
import style0 from "./WorkAuthorization.vue?vue&type=style&index=0&id=48084078&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48084078",
  null
  
)

export default component.exports